import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { DanceStudioPage } from './pages/DanceStudioPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<DanceStudioPage data-id="element-3" />} data-id="element-2" />
      </Routes>
    </BrowserRouter>;
}